// extracted by mini-css-extract-plugin
module.exports = {"btnPurpleIconText":"BtnPurpleIconText_btnPurpleIconText__K2V_9","text":"BtnPurpleIconText_text__3ZFgn","icon":"BtnPurpleIconText_icon__kFCfh"};